import {Component, Input, ElementRef, HostListener, ViewChild} from '@angular/core';
import IMeasurement from "../../interfaces/IMeasurement";
import MeasurementDataProvider from "../../services/measurementDataProvider.service";
import {MapsAPILoader, SebmGoogleMap} from 'angular2-google-maps/core';
import ILocation from "../../interfaces/ILocation";
import * as $ from 'jquery';
import IMapOptions from "../../interfaces/IMapOptions";
import Broadcaster from "../../services/broadcaster.service";
import IBroadcastMessage from "../../interfaces/IBroadcastMessage";
import EVENTS from "../../enums/events.enum";
import MEASUREMENT_TYPES from "../../enums/measurementTypes.enum";
import {googleMapsApiKey} from "../../googleMapsApiKey";

@Component({
    selector: 'map',
    template: require('./map.component.html'),
    styles: [String(require('./map.styl'))],
})

export class MapComponent {
    @HostListener('window:resize', ['$event']) adjustWidth() {
        this.staticMap.width = Math.round(this.mapContainer.width()) + this.staticMap.padding;
    }

    @ViewChild(SebmGoogleMap) sebmGoogleMap: SebmGoogleMap
    @Input() private measurement: IMeasurement;
    @Input() private options: IMapOptions;
    private latlngBounds;
    private url = `https://maps.googleapis.com/maps/api/staticmap?key=${googleMapsApiKey}&maptype=hybrid&size=`;
    private mapContainer;
    private staticMap = {
        width: 0,
        padding: 30
    }
    private brodcasterSubscription;

    constructor(private measurementDataProvider: MeasurementDataProvider,
                private mapsAPILoader: MapsAPILoader,
                private elementRef: ElementRef,
                private broadcaster: Broadcaster) {
        this.mapsAPILoader.load().then(() => {
                this.latlngBounds = new window['google'].maps.LatLngBounds();
                this.measurement.locations.forEach((location: ILocation) => {
                    this.latlngBounds.extend(new window['google'].maps.LatLng(location.lat, location.lng))
                })
            }
        )
    }

    ngOnDestroy() {
        if (this.options.type === 'active')
            this.brodcasterSubscription.unsubscribe();
    }

    ngAfterViewInit() {
        if (this.options.type === 'active')
            this.brodcasterSubscription = this.broadcaster.subscribe((BroadcastMessage: IBroadcastMessage) => {
                if (BroadcastMessage.event === EVENTS.MAP_RESIZE) {
                    setTimeout(() => {
                        this.resizeGoogleMap();
                    }, 300)
                }
            })
        this.mapContainer = $(this.elementRef.nativeElement).find('.map--container');
        this.staticMap.width = Math.round(this.mapContainer.width()) + this.staticMap.padding;
        this.resizeGoogleMap();
    }

    private resizeGoogleMap() {
        if (!this.isStatic()) {
            this.sebmGoogleMap.triggerResize();
        }
    }

    private isStatic() {
        return this.options.type === 'static';
    }

    private resultToString(): string {
        return this.measurementDataProvider.resultToString(this.measurement);
    }


    public isoDateToLocal(measurement: IMeasurement) {
        return this.measurementDataProvider.getDate(measurement);
    }

    public locationToRequestParams(type, locations: ILocation[]): string {
        let params = "&" + type;
        for (let i = 0; i < locations.length; i++) {
            params += locations[i].lat + "," + locations[i].lng + "|"
        }
        return params.substring(0, params.length - 1);
    }

    public generateStaticMapUrl(): string {
        if (!this.mapContainer) {
            return "";
        }
        const fill = (this.measurement.type === MEASUREMENT_TYPES.area) ? 'fillcolor:0xFF0000|' : '';
        return this.url + this.staticMap.width + 'x' + 280 + this.locationToRequestParams('markers=', this.measurement.locations) + this.locationToRequestParams('path=color:0xFF0000|weight:3|' + fill, this.measurement.locations);
    }


}



// WEBPACK FOOTER //
// ./src/app/components/map/map.component.ts